import { Routes } from '@angular/router';
import { EVFunctions } from 'ets-fe-ng-sdk';

export const ParametersRoutes: Routes = [
  {
    path: 'parameters',
    children: EVFunctions.extendRoute2(
      {
        data: { title: `Code` },
        loadComponent: () => import('./code/save-code/save-code.component').then((c) => c.SaveCodeComponent),
      },
      {
        title: 'Home',
        hideTitle: true,
        lazyComponent: () => import('./code/code-home/code-home.component').then((c) => c.CodeHomeComponent),
      },
    ),
  },
];

export default ParametersRoutes;
